import yup from "../../../shared/validation/yupExtensions";
import { ListModel } from "shared/interfaces/core-interfaces";

export interface UnassignedDocumentsSliceModel {
    isLoading: boolean,
    unassignedDocument: UnassignedDocumentResponse | null,
    unassignedDocuments: UnassignedDocumentResponse[],
    unassignedPrivateDocuments: UnassignedDocumentResponse[],
    createData: CreateDataResponse | null
}

export const initialUnassignedDocumentsValue: UnassignedDocumentsSliceModel = {
    isLoading: false,
    unassignedDocument: null,
    unassignedDocuments: [],
    unassignedPrivateDocuments: [],
    createData: {
        documentTypes: [],
        targetTypes: [],
        targets: []
    }
}

export interface UnassignedDocumentResponse {
    id: string;
    name: string;
    uploadedBy: string;
    uploaderId: string;
    uploadedAt: Date;
    documentType: number;
    base64?: string | null;
}

export interface UnassignedDocumentRequest {
    name: string;
    fileBase64: string;
    documentType: number;
    isPrivate: boolean;
}

export interface DownloadDocumentResponse {
    name: string;
    content: string;
}

export interface CreateDataResponse {
    documentTypes: ListModel<number>[] | [],
    targetTypes: ListModel<number>[] | [],
    targets: ListModel<string>[] | []
}

export interface AssignDocumentRequest {
    documentId?: string | null;
    targetId: string;
    targetType: number;
    deleteOriginal: boolean;
}

export const initAssignDocumentRequest: AssignDocumentRequest = {
    documentId: null,
    targetId: "",
    targetType: -1,
    deleteOriginal: true
};

export const AssignDocumentRequestScheme = yup.object().shape({
    documentId: yup.string().nullable(),
    targetId: yup.string().required("Target is required."),
    targetType: yup.number().transform((value) => Number.isNaN(value) ? null : value).min(0, "Target type is required.").required("Target type is required."),
    deleteOriginal: yup.boolean().required("Delete original is required.")
})